"use client";

import { create } from "zustand";

type AgentMode = "light" | "pro" | "max";

const STORAGE_KEY = "bash-agent-mode";
const DEFAULT_MODE: AgentMode = "pro";

function loadMode(): AgentMode {
  if (typeof window === "undefined") return DEFAULT_MODE;
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "light" || stored === "pro") return stored;
  // 'max' is locked behind Max plan — fall back to pro if stored from a prior session
  return DEFAULT_MODE;
}

interface ModeState {
  mode: AgentMode;
  setMode: (mode: AgentMode) => void;
}

export const useModeStore = create<ModeState>((set) => ({
  mode: loadMode(),
  setMode: (mode) => {
    localStorage.setItem(STORAGE_KEY, mode);
    set({ mode });
  },
}));
